import React from 'react'
import { HBox } from './HBox'
import { Plus } from 'phosphor-react'
import { Avatar, Typography, Box } from '@mui/material'

import i18n from '@/i18n'

export function UsersView({
  users,
  visibleUsers = 3
}) {
  return (
    <HBox>
      <HBox sx={{ width: 40 }}>
        {users.slice(0, visibleUsers).map((user, i) => (
          <React.Fragment key={user.id}>
            <Box sx={{ position: 'absolute', top: 6 , left: 6 + i * 12, zIndex: i }}>
              <Avatar sx={{ width: 28, height: 28 }} src={user.imageUrl} />
            </Box>
          </React.Fragment>
        ))} 
      </HBox>
      <HBox sx={{ flex: 1 }}>
      {users.slice(0, visibleUsers).map((user, i) => (
        <Typography key={user.id}>{i > 0 ? ', ' : ''}{user.firstName} {i < 1 && users.length == 1 && user.lastName}</Typography>
      ))}
      {users?.length > visibleUsers && (
        <Typography>
          + {users.length - visibleUsers} {i18n.t('more')}
        </Typography>
      )}
      </HBox>
    </HBox>
  )
}